import { IoLogoFacebook, IoLogoInstagram } from "react-icons/io";
import React from "react";


export const Icons = [
  { name: "logo-facebook", component: <IoLogoFacebook />, link: "https://www.facebook.com/profile.php?id=61560770701944" },
  { name: "logo-instagram", component: <IoLogoInstagram />, link: "https://www.instagram.com/sepiyar.aesthetics/" },
];